import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const redirectEntity: Entity = {
  model: model,
  repository: repository,
}

export default redirectEntity
